module.exports = __webpack_public_path__ + "static/img/course_selection_widget_3.053a4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/course_selection_widget_3.png
// module id = ZrUD
// module chunks = 11